import XSocial from './XSocial'

export default XSocial
// eslint-disable-next-line import/export
export * from './XSocial'
